<template>
  <div class="input-group input-group-sm select-group rz-date-picker" style="padding: 0" @click.stop="">
    <span
      v-if="this.title"
      class="input-group-addon el-input-group__prepend select-prepend"
      style="line-height: 30px; text-align: right;"
    >
      {{ title }}
    </span>
    <input
      type="text"
      ref="timeRange"
      readonly
      class="picker-input el-input__inner"
      :style="inputStyle"
      :placeholder="placeholder"
      :class="inputClass"
      :disabled="disabled"
    />
    <span class="glyphicon glyphicon-calendar date-picker-icon"> </span>
  </div>
</template>

<script>
import moment from 'moment'
require('./daterangepicker.js')

const root = window

export default {
  props: {
    title: {
      // 标题
      type: String,
      default: ''
    },
    timePicker: {
      // 是否显示时间选择器
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '选择时间范围'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    ranges: {
      type: Array,
      default: ['今天', '昨天', '本周']
    },
    startTime: {
      // 开始时间,需加sync属性
      default: ''
    },
    endTime: {
      // 结束时间,需加sync属性
      default: ''
    },
    value: {
      default: []
    },
    maxDate: {
      type: Object,
      default: () => new Date()
    },
    autoUpdate: {
      // 初始化后是否自动赋值，默认为近7天
      type: Boolean,
      default: true
    },
    type: {
      //下拉选项类型before:['今天', '昨天', '本周', '近7天', '本月', '近30天', '近三个月']
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputStyle: {
      default: {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rangeOption: {
        今天: [moment().startOf('days'), moment().endOf('days')],
        昨天: [
          moment()
            .subtract(1, 'days')
            .startOf('days'),
          moment()
            .subtract(1, 'days')
            .endOf('days')
        ],
        本周: [
          moment()
            .startOf('week')
            .startOf('days'),
          moment()
            .endOf('week')
            .endOf('days')
        ],
        近7天: [
          moment()
            .subtract(6, 'days')
            .startOf('days'),
          moment().endOf('days')
        ],
        本月: [
          moment()
            .startOf('month')
            .startOf('days'),
          moment()
            .endOf('month')
            .endOf('days')
        ],
        近30天: [
          moment()
            .subtract(29, 'days')
            .startOf('days'),
          moment().endOf('days')
        ],
        近三个月: [
          moment()
            .subtract(3, 'months')
            .startOf('days'),
          moment().endOf('days')
        ],
        近一年: [
          moment()
            .subtract(365, 'days')
            .startOf('days'),
          moment().endOf('days')
        ]
      },
      //autoUpdate: true,
      timePicker: true
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.dispatch('ElFormItem', 'el.form.change', newValue)
        if (!this.daterangepicker) {
          return
        }
        if (!newValue || !newValue[0] || !newValue[1]) {
          this.daterangepicker.data('daterangepicker').clear()
          return
        }
        this.daterangepicker.data('daterangepicker').setStartDate(newValue[0])
        this.daterangepicker.data('daterangepicker').setEndDate(newValue[1])
      },
      deep: true
    },
    startTime(newValue) {
      if (!this.daterangepicker) {
        return
      }
      if (!newValue) {
        this.daterangepicker.data('daterangepicker').clear()
        return
      }
      this.daterangepicker.data('daterangepicker').setStartDate(newValue)
    },
    endTime(newValue) {
      if (!this.daterangepicker) {
        return
      }
      if (!newValue) {
        this.daterangepicker.data('daterangepicker').clear()
        return
      }
      this.daterangepicker.data('daterangepicker').setEndDate(newValue)
    },
    reset() {
      this.daterangepicker.data('daterangepicker').clear()
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!(this.value && this.value[0] && this.value[1]) && !(this.startTime && this.endTime)) {
        this.autoUpdate = false
      }
      this.begin =
        this.value && this.value[0]
          ? new Date(this.value[0])
          : this.startTime
          ? new Date(this.startTime)
          : moment()
              .subtract(6, 'days')
              .startOf('days')
      this.end =
        this.value && this.value[1] ? new Date(this.value[1]) : this.endTime ? new Date(this.endTime) : moment()
      if (this.type === 'before') {
        this.ranges = ['今天', '昨天', '本周', '近7天', '本月', '近30天', '近三个月']
      }
      if (this.type === 'overview') {
        this.ranges = ['今天', '本周', '本月', '近三个月']
      }
      if (this.format === 'YYYY-MM-DD') {
        this.timePicker = false
        if (this.placeholder === '请选择时间范围') {
          this.placeholder = '选择日期范围'
        }
      }
      this.init()
    })
  },
  methods: {
    init() {
      if (!$(this.$refs.timeRange)) {
        return
      }
      let ranges = {}
      this.ranges.forEach(item => {
        ranges[item] = this.rangeOption[item]
      })
      this.daterangepicker = $(this.$refs.timeRange).daterangepicker(
        {
          format: this.format,
          startDate: this.begin, //设置最大日期
          endDate: this.end, //设置结束器日期
          maxDate: this.maxDate, //设置最大日期
          //maxDate: new Date(new Date().getFullYear() + 10, 1, 1),
          isDateLimit: true,
          isClearBtn: this.clearable,
          dateLimit: {
            days: 92
          },
          showDropdowns: true,
          showWeekNumbers: false,
          timePicker: this.timePicker, //显示时间
          timePickerIncrement: 1,
          timePicker12Hour: false, //时间制
          ranges,
          opens: 'right',
          drops: 'down',
          buttonClasses: ['btn', 'btn-sm'],
          applyClass: 'btn-primary',
          cancelClass: 'btn-default',
          separator: ' - ',
          autoUpdate: this.autoUpdate,
          locale: {
            applyLabel: '确定', //确定按钮文本
            cancelLabel: '退出', //取消按钮文本
            clearLabel: '清空',
            fromLabel: '开始',
            toLabel: '结束',
            weekLabel: '周',
            customRangeLabel: '自定义',
            daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
            monthNames: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月'
            ],
            firstDay: 1
          }
        },
        (start, end, label) => {
          let val
          if (start && end) {
            val = [start.format(this.format), end.format(this.format)]
          } else {
            val = ['', '']
          }
          this.$emit('input', val)
          this.$emit('update:startTime', val ? val[0] : '')
          this.$emit('update:endTime', val ? val[1] : '')
          this.$emit('change', val)
          this.$nextTick(() => {
            //调用form表单的验证方法
            this.dispatch('ElFormItem', 'el.form.change', val)
          })
        }
      )
      this.target = this.getScrollParent(this.$refs.timeRange)
      if (this.target) {
        this.target.addEventListener('scroll', this.scroll)
      }
      this.daterangepicker.data('daterangepicker').container[0].addEventListener('click', this.stop)
    },
    scroll() {
      //this.daterangepicker.data('daterangepicker').clickCancel()
      this.daterangepicker.data('daterangepicker').move()
    },
    getScrollParent(element) {
      var parent = element.parentNode

      if (!parent) {
        return element
      }

      if (parent === root.document) {
        // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
        // greater than 0 and return the proper element
        if (root.document.body.scrollTop || root.document.body.scrollLeft) {
          return root.document.body
        } else {
          return root.document.documentElement
        }
      }

      // Firefox want us to check `-x` and `-y` variations as well
      if (
        ['scroll', 'auto'].indexOf(this.getStyleComputedProperty(parent, 'overflow')) !== -1 ||
        ['scroll', 'auto'].indexOf(this.getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
        ['scroll', 'auto'].indexOf(this.getStyleComputedProperty(parent, 'overflow-y')) !== -1
      ) {
        // If the detected scrollParent is body, we perform an additional check on its parentNode
        // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
        // fixes issue #65
        return parent
      }
      return this.getScrollParent(element.parentNode)
    },
    getStyleComputedProperty(element, property) {
      // NOTE: 1 DOM access here
      var css = root.getComputedStyle(element, null)
      return css[property]
    },
    stop(e) {
      e.stopPropagation()
    },
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    }
  },
  beforeDestroy() {
    this.target && this.target.removeEventListener('scroll', this.scroll)
    let popup =
      $(this.$refs.timeRange).data('daterangepicker') && $(this.$refs.timeRange).data('daterangepicker').container
    if (popup) {
      popup.remove()
    }
  }
}
</script>

<style lang="less">
@import './daterangepicker-bs3.css';
.dropdown-menu-daterangepicker {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  .mixin-background-base;
  .cancelBtn:hover {
    color: #333;
  }
  .clearBtn:hover {
    color: #333;
  }
  .ranges {
    li {
      background: none;
      border: none;
      .mixin-font-color;
      &.active {
        .mixin-background;
        .mixin-font-color-active;
        border: none;
      }
      &:hover {
        .mixin-background;
        border: none;
      }
    }
    .input-mini {
      .mixin-input;
    }
  }
  .calendar-date {
    .mixin-background;
    .mixin-border-hover;
    td {
      &.in-range {
        .mixin-background-base;
      }
      &.active {
        .mixin-btn-primary;
      }
      &:hover {
        .mixin-btn-primary;
      }
    }
  }
  select {
    .mixin-background;
  }
  .daterangepicker_end_input,
  .daterangepicker_start_input {
    label {
      .mixin-font-color;
    }
  }
}
</style>
<style scoped lang="less">
.rz-date-picker {
  .picker-input {
    background: rgba(8, 122, 252, 0.1);
    height: 30px;
    font-size: 14px;
    border-radius: 4px;
    font-weight: normal;
    padding-left: 12px;
    padding-right: 25px;
    overflow: hidden;
    width: 100%;
    border: 1px solid #087afc;
  }
}

.date-picker-icon {
  position: absolute;
  height: 30px;
  width: 25px;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  pointer-events: none;
  line-height: 30px;
  z-index: 10;
  text-align: center;
}
.el-input-group__prepend {
  font-size: 14px !important;
}
</style>
